export const ENVIRONMENTS = {
  DEV: 'DEV',
  UAT: 'UAT',
  PROD: 'PROD',
};